export default __webpack_public_path__ + "img/cSbwQgTc.1cf61cca.svg";